import { sendEventToGTM } from '@neptune/analytics-domain';

type SendUserInvitationAcceptedEventParams = {
  senderUsername: string;
  invitationType: 'Workspace' | 'Project';
};

export const useUserInvitationAcceptedEvent = ({
  senderUsername,
  invitationType,
}: SendUserInvitationAcceptedEventParams) => {
  return {
    sendUserInvitationAcceptedEvent: () =>
      sendEventToGTM({
        eventName: 'invitation_accepted',
        senderUsername,
        attributes: {
          invitationType,
        },
      }),
  };
};
